// extracted by mini-css-extract-plugin
module.exports = {"button":"Modal_button__R_gLf","modal":"Modal_modal__w8Blv","close":"Modal_close__YhyXF"};